import { styled } from "@mui/material";
import { colorPickerName } from "../../../../../../../classes.js";
const TextPlacer = styled("div", {
  name: colorPickerName,
  slot: "TextPlacer"
})(() => ({
  height: "100%",
  left: "0",
  position: "absolute",
  top: "0",
  width: "100%"
}));
export {
  TextPlacer
};
//# sourceMappingURL=TextPlacer.js.map
